import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    '& > p': {
      margin: '0'
    },
    '& > div ': {
      margin: '0',
      display: 'inline'
    },
    '& > div *': {
      margin: '0',
      display: 'inline'
    }
  }
}))

export default useStyles
